import React, { useState, useContext, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";
import { Editor } from "./EditorTexto"; // Importamos tu nuevo Editor

const Edit = ({ productData }) => {
  const { dbCategories, loadProducts } = useContext(CartContext);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  // Estados para imágenes y datos
  const [images, setImages] = useState([null, null, null]);
  const [previews, setPreviews] = useState(["", "", ""]);
  const [formData, setFormData] = useState({ ...productData });

  // Sincronizar formData si productData cambia externamente
  useEffect(() => {
    setFormData({ ...productData });
  }, [productData]);

  const handleShow = () => {
    let currentPreviews = ["", "", ""];
    if (productData.imagenes) {
      try {
        const data =
          typeof productData.imagenes === "string"
            ? JSON.parse(productData.imagenes)
            : productData.imagenes;

        if (Array.isArray(data)) {
          data.forEach((item, i) => {
            if (i < 3 && item) {
              currentPreviews[i] = item.url ? item.url : item;
            }
          });
        }
      } catch (e) {
        console.error("Error parseando imágenes", e);
      }
    }
    setFormData({ ...productData });
    setPreviews(currentPreviews);
    setImages([null, null, null]);
    setShow(true);
  };

  const handleImageChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);

      const newPreviews = [...previews];
      newPreviews[index] = URL.createObjectURL(file);
      setPreviews(newPreviews);
    }
  };

  const removeImage = (index) => {
    const newPreviews = [...previews];
    newPreviews[index] = "";
    setPreviews(newPreviews);

    const newImages = [...images];
    newImages[index] = null;
    setImages(newImages);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const data = new FormData();

    // Campos básicos
    data.append("id", formData.id);
    data.append("titulo", formData.titulo);
    data.append("categoria", formData.categoria);
    data.append("descripcion", formData.descripcion || "");
    data.append("precio", formData.precio);
    data.append("stock", formData.stock);
    data.append("estado", formData.estado);

    // Lógica de imágenes
    previews.forEach((p, i) => {
      if (images[i]) {
        data.append(`image_${i}`, images[i]);
      } else if (p && !p.startsWith("blob:")) {
        data.append(`existing_image_${i}`, p);
      }
    });

    try {
      const resp = await fetch(
        "https://espacioanalogico.com.ar/api/update_product.php",
        {
          method: "POST",
          body: data,
          credentials: "include",
        },
      );

      const res = await resp.json();

      if (res.success) {
        Swal.fire({
          icon: "success",
          title: "¡Actualizado!",
          text: "El producto se guardó correctamente.",
          timer: 2000,
          showConfirmButton: false,
        });

        await loadProducts();
        setShow(false);
      } else {
        Swal.fire("Error", res.message || "No se pudo actualizar", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Error de conexión con el servidor", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-link text-primary p-0 border-0"
        onClick={handleShow}
      >
        <i className="bi bi-pencil-square fs-5"></i>
      </button>

      <Modal show={show} onHide={() => setShow(false)} size="md" centered>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title className="h5">Editar Producto</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* SELECTOR DE IMÁGENES */}
            <div className="row g-2 mb-3">
              {[0, 1, 2].map((i) => (
                <div key={i} className="col-4 position-relative">
                  <div
                    onClick={() =>
                      document.getElementById(`edit-img-${i}`).click()
                    }
                    className="border rounded d-flex align-items-center justify-content-center bg-light"
                    style={{
                      height: "90px",
                      cursor: "pointer",
                      overflow: "hidden",
                    }}
                  >
                    {previews[i] ? (
                      <img
                        src={previews[i]}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        alt=""
                      />
                    ) : (
                      <i className="bi bi-camera text-muted"></i>
                    )}
                  </div>
                  {previews[i] && (
                    <button
                      type="button"
                      className="btn btn-danger btn-sm position-absolute"
                      style={{
                        top: "-5px",
                        right: "5px",
                        borderRadius: "50%",
                        padding: "2px 6px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeImage(i);
                      }}
                    >
                      <i className="bi bi-x"></i>
                    </button>
                  )}
                  <input
                    type="file"
                    id={`edit-img-${i}`}
                    hidden
                    onChange={(e) => handleImageChange(i, e)}
                  />
                </div>
              ))}
            </div>

            <div className="row">
              <div className="col-6 mb-3">
                <Form.Label className="fw-bold small">Estado</Form.Label>
                <Form.Select
                  value={formData.estado}
                  onChange={(e) =>
                    setFormData({ ...formData, estado: e.target.value })
                  }
                >
                  <option value="activo">Activo</option>
                  <option value="pausado">Pausado</option>
                </Form.Select>
              </div>
              <div className="col-6 mb-3">
                <Form.Label className="fw-bold small">Categoría</Form.Label>
                <Form.Select
                  required
                  value={formData.categoria}
                  onChange={(e) =>
                    setFormData({ ...formData, categoria: e.target.value })
                  }
                >
                  {dbCategories.map((cat) => (
                    <option key={cat.id} value={cat.nombre}>
                      {cat.nombre}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold small">Título</Form.Label>
              <Form.Control
                required
                value={formData.titulo}
                onChange={(e) =>
                  setFormData({ ...formData, titulo: e.target.value })
                }
              />
            </Form.Group>

            {/* AQUÍ EL EDITOR ACTUALIZADO */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold small">Descripción</Form.Label>
              <Editor
                descripcion={formData.descripcion || ""}
                cargarDescripcion={(val) =>
                  setFormData({ ...formData, descripcion: val })
                }
              />
            </Form.Group>

            <div className="row">
              <div className="col-6">
                <Form.Label className="fw-bold small">Precio ($)</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.precio}
                  onChange={(e) =>
                    setFormData({ ...formData, precio: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <Form.Label className="fw-bold small">Stock</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.stock}
                  onChange={(e) =>
                    setFormData({ ...formData, stock: e.target.value })
                  }
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="light" onClick={() => setShow(false)}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Guardando..." : "Actualizar Producto"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Edit;
